import { genericService } from "./genericService";

const section = "Destination";

function filter(name = " ", from = "0", limit = "10", active = "1") {
  return genericService.filter(section, "destinations", name, from, limit, active);
}

function getAll() {
  return genericService.get("Destination/ListAllDestination");
}

function remove(id) {
  return genericService.remove(section, id);
}

function create(item) {
  const param = {
    Destination: item.dirDestination,
  };
  return genericService.create(section, param);
}

function update(item) {
  const param = {
    id: item.id,
    Destination: item.dirDestination,
    observaciones1: "",
    observaciones2: "",
    isActive: item.isActive,
  };
  return genericService.update(section, param);
}

export const tipoviajeService = {
  getAll,
  filter,
  remove,
  create,
  update,
};
